import * as reactQuery from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import { CountertopUniversityProfileCreationResult } from "../types/CountertopUniversityProfileCreationResult";

export const useCreateCountertopUniversityProfile = (
	profileName: string,
	onSuccess: (profileID: number) => void,
	onError: (error: string) => void) => {

	const { mutate, isLoading } = reactQuery.useMutation({
		mutationFn: async () => {
			return await apiClient.post("countertop-university/create-profile", {
				profileName: profileName,
			}) as CountertopUniversityProfileCreationResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess) {
				onSuccess(result.profileID); // Pass the profileID to the onSuccess callback
			} else {
				onError('Error when creating profile: ' + result.errorMessage!);
			}
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}
